/* eslint-disable max-len */
import { Component } from 'react';
import PropTypes from 'prop-types';

class InformationBoxComponent extends Component {
  constructor(props) {
    super(props);

    this.onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler(e) {
    this.props.onClickHandler(e);
  }

  render() {
    const { classNames } = this.props;

    return (
      <div className={classNames} >
        <svg
          version="1.1" id="Capa_1" x="0px" y="0px"
          viewBox="0 0 468.1 468.1"
          onClick={this.onClickHandler}
        >
          <g>
            <g>
              <g>
                <path
                  className="st0" d="M234.1,468.1c-62.5,0-121.3-24.3-165.5-68.6C24.3,355.4,0,296.6,0,234.1S24.3,112.8,68.6,68.6
                S171.5,0,234.1,0s121.3,24.3,165.5,68.6c44.2,44.2,68.6,103,68.6,165.5s-24.3,121.3-68.6,165.5
                C355.4,443.8,296.6,468.1,234.1,468.1z M234.1,20c-57.2,0-110.9,22.3-151.4,62.7S20,176.9,20,234.1c0,57.2,22.3,110.9,62.7,151.4
                c40.4,40.4,94.2,62.7,151.4,62.7s110.9-22.3,151.4-62.7c40.4-40.4,62.7-94.2,62.7-151.4c0-57.2-22.3-110.9-62.7-151.4
                C345,42.3,291.2,20,234.1,20z"
                />
                <rect x="206.7" y="184.9" className="st0" width="43.7" height="174.9" />
                <rect x="206.7" y="119.3" className="st0" width="43.7" height="43.7" />
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

InformationBoxComponent.propTypes = {
  classNames: PropTypes.string,
  onClickHandler: PropTypes.func,
};

InformationBoxComponent.defaultProps = {
  classNames: '',
  onClickHandler: () => {},
};

export default InformationBoxComponent;
